//GeneratorFlag:[NoChange]
import { Server } from '@/core/server'
export default class LetterPatternService
{
	constructor(){}

	server(config)
	{
		return new Server(config)
	}

	//GeneratorFlag:[LetterPattern.Create]
	async create(params, config)
	{
		config = config || {};
		if (config.HSR == undefined) config.HSR = true;
		if (config.HER == undefined) config.HER = true;
	
		const _server = 
			this.server(config);
	
		return await _server.post('/aut/letter-pattern/create', params || { });
	};

	//GeneratorFlag:[LetterPattern.Delete]
	async delete(letterPatternId, config)
	{
		config = config || {};
		if (config.HSR == undefined) config.HSR = true;
		if (config.HER == undefined) config.HER = true;
	
		const _server = 
			this.server(config);
	
		const params = {
			id:letterPatternId
		}
	
		return await _server.delete('/aut/letter-pattern/delete', {'params':params})
	};

	//GeneratorFlag:[LetterPattern.Detail]
	async detail(params, config)
	{
		config = config || {};
		if (config.HSR == undefined) config.HSR = false;
		if (config.HER == undefined) config.HER = true;
	
		const _server = 
			this.server(config);
	
		return await _server.get('/aut/letter-pattern/detail', {'params':params});
	};

	//GeneratorFlag:[LetterPattern.List]
	async list(params, config)
	{
		config = config || {};
		if (config.HSR == undefined) config.HSR = false;
		if (config.HER == undefined) config.HER = true;
	
		const _server = 
			this.server(config);
	
		return await _server.get('/aut/letter-pattern/list', {'params':params});
	};

	//GeneratorFlag:[LetterPattern.Update]
	async update(params, config)
	{
		config = config || {};
		if (config.HSR == undefined) config.HSR = true;
		if (config.HER == undefined) config.HER = true;
	
		const _server = 
			this.server(config);
	
		return await _server.post('/aut/letter-pattern/update', params || { });
	};

//GeneratorFlag:[NewAction]
}